import { QuestionBase } from './question-base';

export class InputQuestion extends QuestionBase<string> {
   ptctNo = 'input';
}
